import React, { useCallback, useEffect, useMemo, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { createSearchParams, useNavigate } from "react-router-dom";
import { selectHotelRoomAsync } from "../../../../../features/bookings/hotelSlice";
import { getLogin } from "../../../../../features/userSlice";
import MainModal from "../../../../modals/MainModal";
import CancelPolicies from "../../../../UI/CancelPolicies";

const SelectRoom = ({ rooms, loader }) => {
  const [show, setShow] = useState(false);
  const [modal, setModal] = useState("dailyRates");
  const [code, setCode] = useState("");
  const [roomdailyRate, SetRoomdailyRate] = useState([]);
  // const [loginRedire,]
  const [isBook, setIsBook] = useState(false);

  const navigate = useNavigate();
  const dispatch = useDispatch();

  let login = useSelector(getLogin);

  // useEffect(() => {

  // }, []);

  useEffect(() => {
    let Obj = JSON.parse(sessionStorage.getItem("hotelForm"));
    Obj.BookingCode = code;
    if (code !== "" && isBook === true) {
      if (login?.role === "Agent") {
        window.location.reload();
      } else {
        navigate({
          pathname: "/hotel-review",
          search: `${createSearchParams(Obj)}`,
        });
      }
    }
  }, [login]);

  const handleSelectRoom = (code) => {
    setCode(code);
    setIsBook(true);
    if (Object.keys(login).length > 0) {
      let Obj = JSON.parse(sessionStorage.getItem("hotelForm"));
      Obj.BookingCode = code;
      navigate({
        pathname: "/hotel-review",
        search: `${createSearchParams(Obj)}`,
      });
    } else {
      setModal("login");
      setShow(true);
    }
  };
  useEffect(() => {
    if (roomdailyRate.length > 0) {
      setModal("dailyRates");
      setShow(true);
    }
  }, [roomdailyRate]);

  const dailyRoomHandler = (val) => {
    SetRoomdailyRate([]);
    setTimeout(() => {
      SetRoomdailyRate(val.DayRates[0]);
    }, 100);
  };

  if (rooms !== undefined) {
    return (
      <>
        <section className="select-room mt-5 ">
          <div className="container">
            <div className="row">
              <div className="col-lg-12">
                <div className="select-room-main">
                  <h5 className="title mb-0">Select Room</h5>
                </div>
              </div>
            </div>
          </div>
        </section>

        <section>
          <div className="container">
            <div className="row">
              <div className="col-lg-12">
                <div className="wrapper">
                  <table className="c-table">
                    <thead className="c-table__header">
                      <tr>
                        <th className="c-table__col-label">Room Type</th>
                        <th className="c-table__col-label">Room Option</th>
                        <th className="c-table__col-label">Inclusion</th>
                        <th className="c-table__col-label">Price</th>
                      </tr>
                    </thead>
                    <tbody className="c-table__body">
                      {loader === false && rooms.length === undefined && (
                        <tr>
                          <td colSpan={4} className="p-3">
                            <div className="my-trip-wrap hotel-listing-wrap">
                              <div className="my-trip-img-wrap">
                                <img
                                  src="assets/images/my-trip/bag-boy.svg"
                                  alt="bag-boy"
                                />
                              </div>
                              <div className="my-trip-text p-3">
                                <h4 className="b-b-24">No Rooms Available.</h4>
                                <p className="medium16">
                                  Please Modify Your Search.
                                </p>
                              </div>
                            </div>
                          </td>
                        </tr>
                      )}

                      {loader ? (
                        <tr>
                          <td colSpan={4}>
                            <div class="row mt-3 w-100 p-3">
                              <div class="col-lg-3">
                                <div class="loader-bg structure-box2"></div>
                              </div>
                              <div class="col-lg-3">
                                <span class="loader-bg p-3 mb-1 d-inline-block w-75 rounded"></span>
                                <span class="loader-bg pt-4 mb-1 d-inline-block w-50 me-2 rounded"></span>
                                <span class="loader-bg pt-4 mb-1 d-inline-block w-50 me-2 rounded"></span>
                              </div>
                              <div class="col-lg-3">
                                <span class="loader-bg p-3 mb-1 d-inline-block w-75 rounded"></span>
                                <span class="loader-bg pt-4 mb-1 d-inline-block w-50 me-2 rounded"></span>
                              </div>
                              <div class="col-lg-3">
                                <span class="loader-bg p-3 mb-2 d-block w-25 rounded"></span>
                                <span class="loader-bg p-3 mb-2 d-block w-50 rounded"></span>
                                <span class="loader-bg pt-4 mb-2 d-block w-75 me-2 rounded"></span>
                                <span class="loader-bg pt-4 mb-2 d-block w-50 me-2 rounded"></span>
                              </div>
                            </div>
                          </td>
                        </tr>
                      ) : rooms !== undefined && rooms.length > 0 ? (
                        rooms.map((val, i) => (
                          <tr key={i}>
                            <td className="c-table__cell">
                              {val.Name.map((ele, ind) => {
                                return (
                                  <div className="table-detail">
                                    <div className="room-select-img">
                                      <ul className="my-auto">
                                        <li key={ind}>
                                          <h5>
                                            {ind + 1}. {ele}
                                          </h5>
                                        </li>
                                      </ul>
                                    </div>
                                  </div>
                                );
                              })}
                            </td>
                            <td className="c-table__cell">
                              <div className="table-detail">
                                <CancelPolicies vals={val.CancelPolicies} />
                              </div>
                            </td>
                            <td className="c-table__cell">
                              <div className="table-detail">
                                {val.Inclusion.split(",").map((ele, ind) => {
                                  return (
                                    <p
                                      className="g-text semi-13 mt-0"
                                      key={ind}
                                    >
                                      <img
                                        src="assets/images/hotel/gray-check.svg"
                                        className="green-check"
                                        alt="green-check"
                                      />
                                      {ele}
                                    </p>
                                  );
                                })}
                                {val.IsRefundable && (
                                  <p className="g-text semi-13 mt-0">
                                    <img
                                      src="assets/images/hotel/gray-check.svg"
                                      className="green-check"
                                      alt="green-check"
                                    />
                                    Refundable
                                  </p>
                                )}
                                {val.withTransfers && (
                                  <p className="g-text semi-13 mt-0">
                                    <img
                                      src="assets/images/hotel/gray-check.svg"
                                      className="green-check"
                                      alt="green-check"
                                    />
                                    Transfarable
                                  </p>
                                )}
                              </div>
                            </td>
                            <td className="c-table__cell">
                              <div className="">
                                <p className="g-text pointer">
                                  Total Fare{" "}
                                  <span
                                    onClick={() => {
                                      dailyRoomHandler(val);
                                    }}
                                  >
                                    <i className="fas fa-info-circle"></i>
                                  </span>
                                </p>
                                <h2>
                                  {/* {currentCurrency(props.rooms[0].Currency)} */}
                                  <i className="fas fa-dollar-sign"></i>{" "}
                                  {val.TotalFare}
                                </h2>
                                {/* {val.TotalTax !== 0} */}
                                <p>
                                  Including{" "}
                                  <i className="fas fa-dollar-sign"></i>{" "}
                                  {/* {currentCurrency(props.rooms[0].Currency)}{" "} */}
                                  {val.TotalTax} &amp; fees
                                </p>

                                <span
                                  className="cmn-btn"
                                  onClick={() =>
                                    handleSelectRoom(val.BookingCode)
                                  }
                                >
                                  Select Room
                                </span>
                              </div>
                            </td>
                          </tr>
                        ))
                      ) : null}
                    </tbody>
                  </table>
                </div>
                {/*  */}
              </div>
            </div>
          </div>
        </section>
        {show ? (
          <MainModal
            modal={modal}
            setShow={setShow}
            show={show}
            setModal={setModal}
            extraData={roomdailyRate}
          />
        ) : null}
      </>
    );
  }
};

export default SelectRoom;
